var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDesktopVersion())?_c('article-multiple-desktop-page'):(_vm.$root.template === 'video_template' || _vm.$root.template === 'slider_template')?_c('article-multiple-page'):_c('article-single-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }